<template>
  <div>
    <ContentBox
      :actions="actions"
      :size="{ height: '70vh' }"
    >
      <!-- :actions="actions" -->
      <template slot="top">
        <Filters />
      </template>

      <div class="content">
        <Editor />
        <ListTable />
        <!-- <ListTable v-if="filterSelectionCheck" /> -->
        <!-- <ListHidden v-else /> -->
      </div>
    </ContentBox>
  </div>
</template>

<script>
import { default as actions } from "./actions";
import ContentBox from "@/components/common-ui/content-box/index.vue";

export default {
  components: {
    ContentBox,
    Editor: () => import("./editor.vue"),
    ListTable: () => import("./subcomponents/list-table.vue"),
    // ListHidden: () => import("./subcomponents/list-hidden.vue"),
    Filters: () => import("./subcomponents/filters.vue")
  },
  computed: {
    actions() {
      return actions;
    }
  }
}
</script>

<style>

</style>
